<template>
  <div
    id="uap-ui"
    :class="{ 'ios-fullscreen': isIosFullscreen }">
    <div
      v-if="isShowLoading"
      class="dev-custom-loader loading-page">
      <BliketLoaderCustom />
    </div>
    <div v-if="!isShowLoading">
      <DesktopBanner v-if="isBannerVisible" />
      <RestrictedPage v-else-if="isBlacklisted" />
      <template v-else>
        <div class="view">
          <router-view />
        </div>
        <Menu v-if="isShowMenu" />
      </template>
    </div>
  </div>
</template>

<script src="./js/app"></script>

<style lang="scss" scoped>
#uap-ui {
  min-height: calc(100vh - 62px);
  margin: 54px 0 0;
  font-family: bliket.$blu-font-family-body-text;
  padding: 0 16px 60px;

  &.ios-fullscreen {
    @include safe-area-padding-top;
  }
}

.content-view {
  flex: 1 1 auto;
}

.loading-page {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 62px);
  width: 100%;
}
</style>
